import React from "react"
import Carousel from "../../Carousel";
import { BigSliderItems } from "../../../Code/Data";
import { SmallSliderItems } from "../../../Code/Data";
import useViewportMinimized from "../../../Code/useViewportMinimized";
import styles from "./styles.module.scss"

export default function LandingPageCarousel() {
    const showMinimized = useViewportMinimized();
    return showMinimized
        ? <><Carousel sliderItems={SmallSliderItems} />
            <div className={styles.footer}>
                An official donation site of
                <br />
                the American Red Cross
            </div></>
        : <Carousel sliderItems={BigSliderItems} />
}